












import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class App extends Vue {
  @Prop({ default: '' }) public title;
  @Prop({ default: '' }) public subTitle;
  @Prop({ default: '数据来源：香港政府一线通及卫生署卫生防预中心' }) public desc;
}
